<template>
<span v-if="any" class="pl-flags" :class="{ 'pl-flags-compact': compact }">
    <span v-if="flags.artwork === 'waiting'" class="pl-flag pl-flag-art" :title="artworkTitle">⏳<template v-if="!compact"> artwork</template></span>
    <span v-else-if="flags.artwork === 'in' && showIn" class="pl-flag pl-flag-artin" :title="artworkTitle">✓<template v-if="!compact"> artwork in</template></span>
    <span v-if="flags.priority" class="pl-flag pl-flag-pri" title="Priority">★</span>
    <span v-if="flags.redo" class="pl-flag pl-flag-redo" title="A redo — the item name says so, or the redo tick is set">{{ compact ? 'R' : 'REDO' }}</span>
    <span v-if="flags.preproduction && showPre" class="pl-flag pl-flag-pre" title="Still has pre-production rows open">{{ compact ? 'pre' : 'pre-production' }}</span>
    <span v-if="flags.tbc" class="pl-flag pl-flag-tbc" title="An outbound date on this job is tbc">tbc</span>
</span>
</template>

<script>
import { fmtDay } from './shared';

/**
 * The job's flags as pills — one component for cards, lane rows, checklist
 * rows and chips, so a flag reads the same everywhere (P4,
 * planning/planner-boards-p1-p3-p4-plan.md §2). `flags` is the
 * QAPP\JobFlags shape carried on jobs[].flags / cells[].flags.
 *
 *   compact   glyphs only (⏳ ★ R pre tbc) — the chip corner mark
 *   showIn    also show "✓ artwork in" (off by default: "in" is the quiet state)
 *   showPre   show the derived pre-production pill (off where the card is
 *             already hatched for it)
 */
export default {
    name: 'FlagPills',

    props: {
        flags: { type: Object, default: null },
        compact: { type: Boolean, default: false },
        showIn: { type: Boolean, default: false },
        showPre: { type: Boolean, default: true },
    },

    computed: {
        any() {
            const f = this.flags;
            if (!f) return false;
            return f.artwork === 'waiting' || (f.artwork === 'in' && this.showIn)
                || !!f.priority || !!f.redo || (!!f.preproduction && this.showPre) || !!f.tbc;
        },
        artworkTitle() {
            const f = this.flags || {};
            const state = f.artwork === 'waiting' ? 'Waiting on artwork' : (f.artwork === 'in' ? 'Artwork in' : 'No artwork needed');
            const by = f.artwork_by ? ' — set by ' + f.artwork_by + (f.artwork_at ? ', ' + fmtDay(f.artwork_at.slice(0, 10)) : '') : '';
            return state + by;
        },
    },
};
</script>

<style scoped>
.pl-flags{display:inline-flex; gap:4px; flex-wrap:wrap; align-items:center; vertical-align:middle}
.pl-flag{display:inline-flex; align-items:center; gap:2px; border-radius:4px; padding:0 5px;
    font-size:10.5px; font-weight:800; line-height:17px; letter-spacing:.01em; white-space:nowrap}
.pl-flags-compact .pl-flag{padding:0 3px; font-size:10px; line-height:15px}
.pl-flag-art{color:#52514e; background:#eeede8}
.pl-flag-artin{color:#0a7a0a; background:#e3f4e3}
.pl-flag-pri{color:#8a5a00; background:#fdf3d9}
.pl-flag-redo{color:#b32e2e; background:#f9e4e4}
.pl-flag-pre{color:#898781; background:#f1f0eb; font-weight:700}
.pl-flag-tbc{color:#1f7f7e; background:#e2f2f1}
</style>
